import React from 'react';
import { Heading, PinCenter, Text } from '@marvelapp/ui';
import image from './MobileBadgeOverlay.png';
import Share from './icons/Share';
function HomescreenModal() {
    return (React.createElement(PinCenter, { alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", width: 1 },
        React.createElement(Heading, { color: "white", display: "inline-block", fontFamily: 0, marginBottom: 5, textAlign: "center" }, "How to add to your home screen"),
        React.createElement("img", { src: image, style: { display: 'block', maxWidth: '80%' } }),
        React.createElement(Text, { color: "white", fontFamily: 0, fontSize: 3, marginTop: 5, textAlign: "center" },
            "Tap on the ",
            React.createElement(Share, null),
            " share icon, then Add to Home Screen to add the bookmark to the fullscreen prototype on your phone")));
}
export default HomescreenModal;
